module.exports = __webpack_public_path__ + "static/media/Colette Ray Queen Headboard - 155 cm_Teal.6fa45533.png";